/** @format */
import React from 'react';
import styled from 'styled-components';

import { SortBySelect } from '@toucan/client/features/search/components/sort-by-select';
import { SortByOption } from '@toucan/client/features/search/config/types';

const StyledDesktopSort = styled.div`
    grid-area: sort;
    display: flex;
    justify-content: flex-end;
    padding-right: var(--layout-spacing-24);
`;

export function DesktopSort({
    sortByOptions,
    sortBy,
    onSortByChange,
    className,
}: {
    sortByOptions: SortByOption[];
    sortBy: SortByOption;
    onSortByChange: (sortByOption: SortByOption) => void;
    className?: string;
}) {
    return (
        <StyledDesktopSort className={`${className} sorting`}>
            <SortBySelect
                options={sortByOptions}
                selectedOption={sortBy}
                onSortByChange={(sortByOption: SortByOption) => {
                    onSortByChange(sortByOption);
                }}
                data-testid="search-results__sort-by"
            />
        </StyledDesktopSort>
    );
}
